import { useEffect, useRef, useState } from 'react';
import { useAppSelector } from '../store';

export function useEnergyWorker() {
  const workerRef = useRef<Worker | null>(null);
  const [currentEnergy, setCurrentEnergy] = useState<number>(0);
  const [reload, setReload] = useState(false);

  const { userData } = useAppSelector(({ profile }) => profile);
  const { settings: appSettings } = useAppSelector(({ settings }) => settings);
  const { purchases } = useAppSelector(
    ({ shop }) => shop,
  );
  const userEnergy = Number((userData?.energy || 0).toFixed(5));
  const activeEnergyCapacityEffect = purchases?.find((purchase) => purchase.is_active
      && purchase.store_item_level.effects.map((effect) => effect.name).includes('energy_capacity'))?.store_item_level?.effects[0];
  const maxEnergy = (appSettings?.max_energy || 0) + parseInt(activeEnergyCapacityEffect?.value || '0', 10);
  const energyRecoveryPerSecond = appSettings?.energy_recovery_per_second || 1;
  const energyForSpin = appSettings?.energy_for_spin || 1;

  const getCounter = () => {
    if (currentEnergy >= maxEnergy) {
      return formatCounter(0);
    }

    const energyLeftToSection = energyForSpin - (currentEnergy % energyForSpin);
    const timeLeftToSection = (energyLeftToSection) / energyRecoveryPerSecond;

    return formatCounter(timeLeftToSection);
  };

  const formatCounter = (counter:number) => {
    const hours = Math.floor(counter / 3600);
    const minutes = Math.floor((counter % 3600) / 60);
    const seconds = Math.floor(counter % 60);
    const formatedSecond = seconds < 10 ? `0${seconds}` : seconds.toString();
    const formatedMinutes = minutes < 10 ? `0${minutes}` : minutes.toString();
    const isFinished = counter <= 0;

    return {
      hours, minutes, seconds, formatedSecond, formatedMinutes, isFinished,
    };
  };

  useEffect(() => {
    setCurrentEnergy(userEnergy);
  }, [userEnergy]);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (typeof Worker !== 'undefined' && (!workerRef.current || reload)) {
      if (reload) {
        setReload(false);
      }
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      workerRef.current = new Worker(new URL('../workers/energyWorker.ts', import.meta.url));

      workerRef.current.onmessage = (event) => {
        setCurrentEnergy(event.data.currentEnergy);
      };

      workerRef.current.postMessage({
        energyPerSecond: energyRecoveryPerSecond,
        currentEnergy: userEnergy,
        maxEnergy,
      });

      return () => {
        workerRef.current?.terminate();
        workerRef.current = null;
        setReload(true);
      };
    }
  }, [userEnergy, energyRecoveryPerSecond, maxEnergy]);

  return {
    userEnergy: currentEnergy, energyRecoveryPerSecond, maxEnergy, energyForSpin, counter: getCounter(),
  };
}
